import React from "react";
import { formatCurrency } from "@/lib/format";

export default function MetricCard({ label, value, icon: Icon, accent = "default", testId, sub }) {
  const accents = {
    default: "text-foreground",
    yellow: "text-primary",
    blue: "text-[#3B9BFF]",
    green: "text-emerald-400",
    red: "text-destructive",
    orange: "text-amber-400",
  };
  return (
    <div
      className="rounded-xl border border-border bg-card p-5 transition-colors duration-200 hover:border-primary/40"
      data-testid={testId}
    >
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
        {Icon && <Icon className={`h-5 w-5 ${accents[accent]}`} />}
      </div>
      <div className={`mt-3 font-display text-2xl font-extrabold tabular-nums sm:text-[26px] ${accents[accent]}`}>
        {formatCurrency(value)}
      </div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}
